import React from 'react';
import { styled } from '@teko/ui';
import { DiscoveryBlock } from 'types';
import { Home, getServerSidePropsHome } from 'components/desktop/pages';
import { SideBanners } from 'components/SideBanners';
import { MenuItem } from '@teko/discovery';

export interface HomeProps {
  serverBlocks: DiscoveryBlock[];
  menuItems?: MenuItem[];
}

const StyledSideBanners = styled(SideBanners)`
  top: 8px;
  > div {
    margin-top: 88px;
  }
`;

const HomePage: React.FunctionComponent<HomeProps> = ({
  serverBlocks,
  menuItems,
}: HomeProps) => {
  return (
    <Home
      menuItems={menuItems}
      serverBlocks={serverBlocks}
      sideBanner={<StyledSideBanners />}
    />
  );
};

export const getServerSideProps = getServerSidePropsHome;
export default HomePage;
